var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"App"}},[_c('van-nav-bar',{attrs:{"title":_vm.title}}),_c('van-list',{staticStyle:{"margin-top":"-15px"},attrs:{"finished":_vm.finished,"finished-text":"没有更多了"},on:{"load":_vm.onLoad},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('van-divider'),_vm._l((_vm.list),function(item){return _c('van-cell',{key:item.CODE,attrs:{"title":item.NAME,"label":item.ZRS > 0 ? (
        '总人数:' +
        item.ZRS +
        '; 在现场:' +
        item.ZXC +
        '; 已离场:' +
        item.YLC +
        '; 未入场:' +
        item.WRC +
        ';'
      ) : '',"is-link":"","size":"large"},on:{"click":function($event){return _vm.onClickCell(item)}}})})],2),_c('Tabbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }